import { render, staticRenderFns } from "./ContentTreeNavigation.vue?vue&type=template&id=047e6226"
import script from "./ContentTreeNavigation.vue?vue&type=script&lang=ts"
export * from "./ContentTreeNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports